import api from '@/api';
import Vue from "vue"
import sysInit from './sysInit'
import redmine from './redmine';
const state = {
  collections: [],
  default: true,
  search_flag: '',
  loading: true,
  mapData:'',
  pinData:[],
  autoCompleteInputText:"",
  editorText:"",
  copyCounter:0,
  documentSearchCollection: {
    name: process.env.VUE_APP_WEB_SEARCH_COLLECTION_NAME,
    collection_id: '',
    searchInfo: '',
    dataList:[]
  }
}
const getters = {
  getCollections(state) { return state.collections },
  getDisDefault(state) { return state.default },
  getSearchFlag(state) { return state.search_flag },
}
const actions = {
  fetchCollections(context, item) {
    api.getCollections().then((res) => {
      res.data.data.forEach(v => {
        v.searchInfo = '';
        v.dataList = [];
        v.loading = false;
      });
      context.commit('changeCollections', res.data.data);
      context.commit('changeLoading', false);

    }, (err) => {
      console.log(err);
    });
  },

  // fetchDocumentDisResults(context, params){
  //   state.documentSearchCollection['dataList'] = [];
  //   state.documentSearchCollection.searchInfo = `（${sysInit.state.html_const.cons_253_search_text}）`;
  //   state.documentSearchCollection.loading = true;

  //   let data = {
  //     projectId: process.env.VUE_APP_WEB_SEARCH_PROJECT_ID,
  //     collectionIds: process.env.VUE_APP_WEB_SEARCH_COLLECTION_IDS.split(','),
  //     query_value: params.input,
  //     issue_id: redmine.state.issue_id,
  //     user_id: localStorage.getItem("login_id"),
  //     search_flag: params.search_flag
  //   };
    
  //   api.getWebCrawlResultsByDiscovery(data).then((res) => {
  //     if(res.data.code == 0){
  //       const dataList = res.data.data;
  //       for(let i = 0; i < dataList.length; i++){
  //         let data = {}
  //         data.evaluate = false ;
  //         data.pinFlag = false ;
  //         data.notesDocFlg = false;
  //         data.showAllflag = true;
  //         data.saveFlg = false;
  //         data.copyFlg = false;
  //         let item = dataList[i];
  //         item = Object.assign(item, data);
  //         state.documentSearchCollection['dataList'].push(item);
   
  //         console.log(state.documentSearchCollection)
  //       }
  //       state.documentSearchCollection.loading = false;
  //       state.documentSearchCollection.searchInfo = '（' + dataList.length + '）';
  //     }else{
  //       console.log('getWebCrawlResultsByDiscovery fail');
  //       state.documentSearchCollection.loading = false;
  //     }
  //   }, (err) => {
  //     console.log(err);
  //     state.documentSearchCollection.loading = false;
  //   });

  // },
  fetchDisResults(context, params) {
    for (const collection of params.collections) {
      // if (collection.name == params.collection.name) {
        collection.searchInfo = `（${sysInit.state.html_const.cons_253_search_text}）`;
        collection.loading = true;
      // }
    }
    context.commit('changeCollections', state.collections);
    context.commit('changeSearchFlag', params.search_flag);

    let data = {
      query_value: params.input,
      collectionIds: params.collections.map((i)=>{return i.collection_id}),
      operator_id: 21,
      search_flag:params.search_flag,
      request_id:redmine.state.issue_id
    };
    api.getResultsByDiscovery(data).then((res) => {
      const dataList = res.data.data;
      state.collections.map((q)=>{return q.dataList = []})
      for(let i = 0; i < dataList.length; i++){
        let collection_id = dataList[i]['result_metadata']['collection_id'];
        for (let j = 0; j < state.collections.length; j++) {
          if(state.collections[j].collection_id == collection_id){
            let data = {}
            data.evaluate = false ;
            data.pinFlag = false ;
            data.notesDocFlg = false;
            data.showAllflag = true;
            data.saveFlg = false;
            data.copyFlg = false;
            let item = dataList[i];
            item = Object.assign(item, data);
            state.collections[j]['dataList'].push(item);
            break;
          }
        }
      }
      for (let p = 0; p < state.collections.length; p++) {
        state.collections[p].searchInfo = '（' + state.collections[p].dataList.length + '）';
        state.collections[p].loading = false;
      }
      
      console.log('state.collections', JSON.stringify(state.collections))
      context.commit('changeCollections', state.collections);
      console.log("state.collections",state.collections)
      context.commit('changeDisDefault', res.data.default);
    }, (err) => {
      console.log(err);
    });
  },
  evaluate(context, params) {
    api.discoveryEvaluate(params).then((res) => {
      for(let collection of state.collections){
        if(collection.name == params.collection_name){
          for(const doc of collection.dataList){
            if(doc.hasOwnProperty('data') && doc.data.notesdocid == params.document_id){
              doc.evaluate = true ;
            }
            if(doc.hasOwnProperty('id') && doc.id == params.document_id){
              doc.evaluate = true ;
            }
          }
        }
      }
      context.commit('changeCollections', state.collections);
    }, (err) => {
      console.log(err);
    });
  },
  markdoc(context, params) {
    api.markdoc(params).then((res) => {

       if(JSON.stringify(res.data) !="{}"){
        // if(res.data.code!= 1001){
        //   if (res.data.data.d3 != undefined){
        //     context.dispatch("echart/echartInit",{type:'map',data:res.data.data.d3}, {root: true});
        //     context.dispatch("echart/echartInit",{type:'minmap',data:res.data.data.d3}, {root: true});
        //     context.commit('changeMapData', res.data.data.d3);
        //   }
    
        //   if(res.data.data.d3.nodes && res.data.data.d3.nodes.length > 0){
        //     context.commit("changeMapData",res.data.data.d3);
        //     context.commit("sysInit/changeCurrentKeyword", res.data.data.notesitem,{root: true});
        // }
        // }
      }
      
     
    }, (err) => {
      console.log(err);
    });
  },
  pin(context, params) {
    for(let collection of state.collections){
      if(collection.name == params.collection.name){
        for(let doc of collection.dataList){
          if(doc.data.notesdocid == params.document.data.notesdocid){
            doc.pinFlag = !doc.pinFlag ;
            break;
          }
        }
      }
    }
    state.pinData = []; 
    for(let collection of state.collections){
      for(let doc of collection.dataList){
        if(doc.pinFlag){
          state.pinData.push({
            collection_name:collection.name,
            doc_id:doc.data.notesdocid,
            doc:{...doc,evaluate:true},
          })
        }
      }
    }
    context.commit('changeCollections', state.collections);

  },
  disRequestListSaveInfo(context, params){

    api.disRequestListSaveInfo(params).then((res)=>{
      console.log(res);
    },(err)=>{
      console.log(err);
    })
  }
}
const mutations = {
  changeCollections(state, collections) {
    state.collections = collections;
    if(state.collections[0]){
      Vue.set(state.collections,0,state.collections[0]);
    }
  },
  changeDisDefault(state, value) {
    state.default = value;
  },
  changeSearchFlag(state, search_flag) {
    state.search_flag = search_flag;
  },
  changeLoading(state, status) {
    state.loading = status;
  },
  changeMapData(state, mapData) {
    state.mapData = mapData;
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
